import polygon from "../../assets/images/Rectangle 347.png";
import logo from "../../assets/images/mainlogo1.png";
import appIcon from "../../assets/icons/Fameo-X-App-icon.png";
import classes from "./Bg.module.css";
import { useState, useEffect } from "react";
// import profileSetup from "../../assets/images/user.png";
const Bg = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth < 431);

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth < 431);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<div className={classes.bg}>
			<div className={classes.logo}>
				<img src={isMobile ? appIcon : logo} alt="logo" />
			</div>
			<div className={classes.white}>
				<img src={polygon} alt="" />
			</div>
		</div>
	);
};

export default Bg;


